<template>
    <section class="leaderboard-section">
        <div class="leaderboard-section__row">
            <div class="section-title">
                <div class="section-title__title">LEADERBOARD</div>
            </div>

            <div class="leaderboard-section__body">
                <!-- stand only: moved up from the games section, so the code is
                     beside the standings instead of further down the page -->
                <div v-if="isStandMode" class="tournament-qr">
                    <div class="qr-frame">
                        <img
                            v-if="tournament?.qr_code_url"
                            :src="tournament.qr_code_url"
                        />
                        <div v-else class="no-img">QR Code</div>
                    </div>
                </div>

                <TournamentLeaderboardComponent
                    :leaderboard-data="leaderboardData"
                    :date-locale="dateLocale"
                    :date-time-zone="dateTimeZone"
                />
            </div>
        </div>
    </section>
</template>

<script>

import TournamentLeaderboardComponent from "@/pages/tournament/components/tournament_leaderboard_component";


export default {
    name: "TournamentLeaderboardSection",
    props: {
        leaderboardData: {
            type: Array,
            default: [],
        },
        tournament: {
            type: Object,
            default: () => ({}),
        },
        isStandMode: {
            type: Boolean,
            default: false,
        },
        dateLocale: {
            type: String,
            default: undefined,
        },
        dateTimeZone: {
            type: String,
            default: undefined,
        }
    },
    components: {
        TournamentLeaderboardComponent,
    }
}
</script>

